<template>
  <vue-apex-charts type="pie" height="350" :options="chartOptions" :series="series"></vue-apex-charts>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import is from 'is_js'
export default {
  name: 'PieChart',
  props: ['data', 'location', 'strains'],
  components: {
    VueApexCharts
  },
  watch: {
    data(v) {
      this.series = v
    },
    location() {
      this.chartOptions.labels = this.getLabels()
    },
    strains() {
      this.chartOptions.labels = this.getLabels()
    }
  },
  data() {
    return {
      chartOptions: {
        labels: [],
        colors: ['#008cff', '#28C76F', '#EA5455', '#FF9F43', '#e5ff00', '#1E1E1E'],
        legend: {
          show: false
        },
        dataLabels: {
          enabled: false
        },
        tooltip: {
          y: {
            formatter(val, w) {
              const sum = w.globals.seriesTotals.reduce((a, b) => {
                return a + b
              }, 0)
              const x = sum === 0 ? 0 : Math.round((val / sum) * 100)
              return `${x}%`
            }
          }
        },
        plotOptions: {
          pie: {
            customScale: 0.2
          }
        }
      },
      series: []
    }
  },
  created() {
    this.chartOptions.labels = this.getLabels()
    this.series = is.not.undefined(this.data) ? this.data : this.series
  },
  methods: {
    getLabels() {
      const self = this
      if (is.undefined(this.location)) {
        return is.not.undefined(this.strains) ? this.strains : []
      } else {
        const labels = []

        if (is.not.undefined(this.strains)) {
          this.strains.forEach(function(s) {
            labels.push(`${self.location} Region - ${s}`)
          })
        }
        return labels
      }
    }
  }
}
</script>
